import { render } from "./PaywallCard.vue?vue&type=template&id=64be47e5"
import script from "./PaywallCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paywall/PaywallCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64be47e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64be47e5', __exports__)) {
    api.reload('64be47e5', __exports__)
  }
  
  module.hot.accept("./PaywallCard.vue?vue&type=template&id=64be47e5", () => {
    api.rerender('64be47e5', render)
  })

}


export default __exports__